module.exports = __webpack_public_path__ + "static/img/装饰2.ff16aec.svg";


//////////////////
// WEBPACK FOOTER
// ./src/views/decorativePainting/imgs/装饰2.svg
// module id = 4kmz
// module chunks = 2